export default __webpack_public_path__ + "static/media/en-US.64eb4853.md";